// Mock data for Harvest Education Consulting

export const contactInfo = {
  email: 'Najlaa.Assaf@Harvesteducation.co',
  phone: '+962 79 005 7425',
  whatsapp: '+962790057425',
  address: 'Sophia Plaza, 3rd Floor, Yajouz Rd., Amman, Jordan',
  website: 'harvesteducation.co',
  hours: 'Saturday - Wednesday: 10:00 AM - 4:00 PM',
  socialMedia: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    linkedin: 'https://linkedin.com'
  }
};

export const drNajlaa = {
  name: 'Dr. Najlaa Assaf',
  credentials: 'PhD in Special Education, The University of Jordan',
  experience: '20 years',
  bio: 'Dr. Najlaa Assaf is a passionate advocate for children with special learning needs. With over 20 years of experience and a PhD in Special Education from The University of Jordan, she has dedicated her career to helping children ages 3-14 overcome developmental challenges and reach their full potential. Her evidence-based approach combines compassion with proven methodologies to create lasting positive change in the lives of children and their families.'
};

export const services = [
  {
    id: 1,
    title: 'Speech & Language Development',
    icon: 'MessageCircle',
    color: 'accent-purple',
    description: 'Specialized support for children with limited speech or delayed language development.',
    details: [
      'Language-building routines',
      'Articulation and pronunciation practice',
      'Expressive and receptive language development',
      'Social communication training'
    ]
  },
  {
    id: 2,
    title: 'Attention & Focus Training',
    icon: 'Target',
    color: 'accent-blue',
    description: 'Evidence-based strategies to help children who struggle with focusing or following instructions.',
    details: [
      'Attention span building',
      'Following multi-step directions',
      'Learning readiness skills',
      'Classroom behavior preparation'
    ]
  },
  {
    id: 3,
    title: 'Social Skills Development',
    icon: 'Users',
    color: 'accent-orange',
    description: 'Structured programs to help children interact positively with peers and develop friendships.',
    details: [
      'Turn-taking and sharing',
      'Peer interaction skills',
      'Play and cooperation',
      'Building confidence in social settings'
    ]
  },
  {
    id: 4,
    title: 'Emotional Regulation Support',
    icon: 'Heart',
    color: 'accent-pink',
    description: 'Helping children manage strong emotions, reduce meltdowns, and develop coping strategies.',
    details: [
      'Emotional expression techniques',
      'Self-regulation strategies',
      'Coping mechanisms',
      'Sensory sensitivity support'
    ]
  },
  {
    id: 5,
    title: 'Academic Skills Support',
    icon: 'BookOpen',
    color: 'accent-green',
    description: 'Individualized support for children struggling with reading, writing, or basic academic skills.',
    details: [
      'Reading readiness and literacy',
      'Writing and fine motor skills',
      'Early numeracy concepts',
      'School readiness preparation'
    ]
  },
  {
    id: 6,
    title: 'Sensory Integration Therapy',
    icon: 'Hand',
    imageUrl: null,
    color: 'accent-grey',
    description: 'Occupational therapy support for children with sensory processing challenges.',
    details: [
      'Sensory regulation techniques',
      'Motor coordination development',
      'Handwriting readiness',
      'Daily living skills'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    parent: 'Sarah M.',
    location: 'Amman',
    program: 'Speech & Language',
    duration: '6 months',
    childAge: 5,
    quote: 'When we first came to Harvest, our son barely spoke. Within 6 months, he was forming sentences and actually wanting to communicate. Dr. Najlaa and her team gave us our son back. We are forever grateful.',
    rating: 5
  },
  {
    id: 2,
    parent: 'Ahmad & Layla K.',
    location: 'Amman',
    program: 'Emotional Regulation',
    duration: '4 months',
    childAge: 4,
    quote: 'Our daughter had severe meltdowns every day. The team at Harvest taught her emotional regulation skills that transformed our home life. She is now thriving in preschool and making friends.',
    rating: 5
  },
  {
    id: 3,
    parent: 'Rania T.',
    location: 'Amman',
    program: 'Academic Skills',
    duration: '1 year',
    childAge: 7,
    quote: 'After struggling in school for two years, Harvest individualized approach helped my son finally understand reading. His confidence has soared, and he actually enjoys learning now.',
    rating: 5
  },
  {
    id: 4,
    parent: 'Omar F.',
    location: 'Amman',
    program: 'Occupational Therapy',
    duration: '8 months',
    childAge: 6,
    quote: 'The progress reports and parent coaching at Harvest made us active partners in our daughter growth. We learned strategies we could use at home, which accelerated her development tremendously.',
    rating: 5
  }
];

export const approaches = [
  {
    title: 'Individualized Education Plans (IEP-Style Programming)',
    description: 'Each child follows a personalized plan with clear goals, measurable progress, and regular updates - so parents can see real improvement over time.',
    icon: 'ClipboardList'
  },
  {
    title: 'Applied Behavior Strategies (ABA-Informed Support)',
    description: 'We use behavior-based strategies to support attention, learning readiness, positive behavior development, and communication - always in a respectful, child-centered way.',
    icon: 'TrendingUp'
  },
  {
    title: 'Speech & Language Development Strategies',
    description: 'Structured techniques for language-building routines, articulation practice, and social communication training.',
    icon: 'MessageSquare'
  },
  {
    title: 'Occupational Therapy & Sensory Integration',
    description: 'Programs designed to improve sensory regulation, motor coordination, handwriting readiness, and daily living skills.',
    icon: 'Hand'
  },
  {
    title: 'Social Skills & Emotional Regulation',
    description: 'Helping children develop turn-taking, peer interaction, emotional expression, and coping strategies for school readiness.',
    icon: 'Smile'
  }
];

export const earlyWarnings = [
  {
    icon: 'MessageCircle',
    title: 'Limited speech or delayed language'
  },
  {
    icon: 'Focus',
    title: 'Trouble focusing or following instructions'
  },
  {
    icon: 'Users',
    title: 'Difficulty interacting with other children'
  },
  {
    icon: 'AlertCircle',
    title: 'Strong emotions, meltdowns, or sensory sensitivity'
  },
  {
    icon: 'PenTool',
    title: 'Struggles with reading, writing, or basic skills'
  }
];

export const progressMetrics = [
  'Clear goals and baseline assessment',
  'Progress tracking and session notes',
  'Periodic evaluations and plan updates',
  'Continuous parent communication'
];

// Form submission mock handler
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({ success: true, message: 'Thank you for reaching out! We will contact you within 24 hours.' });
    }, 1000);
  });
};

export const submitBookingForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Booking form submitted:', formData);
      resolve({ success: true, message: 'Your consultation request has been received! We will confirm your appointment shortly.' });
    }, 1000);
  });
};